/* ============================================================
   CUSTOM.JS — Restock Vintage (Y2K Streetwear)
   Interazioni e micro-comportamenti brand.
   Caricato con `defer` dopo gli script core di Dawn.
   ============================================================ */

(function () {
  'use strict';

  // Namespace globale per future estensioni (countdown, wishlist, sticky cta, ecc.)
  window.Restock = window.Restock || {};

  document.addEventListener('DOMContentLoaded', function () {
    // Placeholder — le interazioni arriveranno con i prossimi step:
    //   - Countdown mystery box
    //   - Sticky CTA "Aggiungi al carrello" su mobile
    //   - Wishlist "salva per dopo"
    //   - Newsletter popup gamified
  });
})();
